<template>
    <div id="GoodsList">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">
                <form action="/">
                    <van-search
                        shape = "round"
                        v-model="searchValue"
                        :placeholder="langText.research"
                        @search="onSearch"
                        background="#ffffff"/>
                </form>
            </div>
            <div slot="right">
                <van-image class="main-img" style="width: 24px; height: 24px;" :src="require('@/assets/image/icon/icon_top_gouwuche@2x.png')"/>
            </div>
        </nav-bar>

        <van-tabs v-model="active" color="#1989f9" @click="checkShow">
            <van-tab v-for="index in [langText.synthesize, langText.salesQuantity, langText.price, langText.filter]" :title="index">
                <div class="goods-condition" v-if="conditionSearch">
                    <div style="padding: 0px 10px;">

                        <div class="condition-name">分类</div>
                        <div>
                            <van-grid direction="horizontal" :column-num="4" :border="false">
                                <van-grid-item v-for="(item, index) in categoryList" style="background: #f8f6f7;">
                                    <div class="condition-button" v-bind:class="{'select-condition': conditionCategory == item.id}" @click="addCondition('category',item.id)">{{item.name}}
                                    </div>
                                </van-grid-item>
                            </van-grid>
                        </div>
                        <div class="condition-name">{{langText.brands}}</div>
                        <div>
                            <van-grid direction="horizontal" :column-num="4" :border="false">
                                <van-grid-item v-for="(item, index) in brandList">
                                    <div class="condition-button" v-bind:class="{'select-condition': conditionBrand == item.id}" @click="addCondition('brand',item.id)">{{item.name}}</div>
                                </van-grid-item>
                            </van-grid>
                        </div>

                    </div>
                    <div class="condition-sub">
                        <div class="condition-delete" @click="conditionDelete">{{langText.reset}}</div>
                        <div class="condition-sure" @click="conditionSub">{{langText.confirm}}</div>
                    </div>
                </div>

                <!--商品主体-->
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="!conditionSearch">
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad">
                        <goods-list :goods="goodsList"/>
                    </van-list>
                </van-pull-refresh>

            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import {Icon, Search, Toast, Tabs, Tab, PullRefresh, List, Grid, GridItem, Image } from 'vant';
    import NavBar from "@/components/common/navbar/NavBar";
    import { getProductListByCategory } from  "@/network/goods/goods"
    import { getCategory, getBrandList } from '@/network/category/category'
    import goodsList from "@/components/content/goodsList/goodsList";
    import { langPackage } from "@/config/lang/goodListLang";
    import { selectLang } from "../../config/setLanguage"

    export default {
        name: "GoodsList",
        components: {
            NavBar: NavBar,
            goodsList:goodsList,
            [Icon.name]: Icon,
            [Search.name]: Search,
            [Toast.name]: Toast,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Image.name]: Image,
        },
        data() {
            return {
                searchValue: '',
                active: 0,
                loading: false,
                finished: false,
                refreshing: true,
                goodsList: [],
                conditionSearch: false,
                conditionBrand: this.$route.query.brandId,
                conditionCategory: this.$route.query.categoryId,
                categoryList: [],
                brandList: [],
                keyword: '',
                sort: 1,
                pageNum: 0,
                pageSize: 10,
                minPrice:'',
                maxPrice:'',
                langText:"",
                commonText:"",
                publishStatus: 1,
            }
        },
        methods: {
            goBack() {
                this.$router.back(-1);
            },
            toProductInfo(goodsId){
              this.$router.push({ path: '/goods/goodsInfo/'+ goodsId})
            },
            showCart() {
                this.$router.push({path: '/order/shoppingCart'})
            },
            onSearch(goodsName) {
                this.keyword = goodsName
                this.onRefresh()
            },
            //上拉刷新列表 加载数据
            onRefresh() {
                // 重新加载数据
                    this.pageNum = 0;
                    // 清空列表数据
                    this.goodsList = [];
                    this.finished = false;
                    // 将 loading 设置为 true，表示处于加载状态
                    this.loading = true;

                    //弹窗显示
                    Toast.loading({
                        duration: 0,
                        message: '加载中...',
                        forbidClick: true,
                    });
                    setTimeout(() => {
                        Toast.clear();
                        this.onLoad();
                    }, 1000);
            },
            onLoad() {
                let goodsType = [1,2,3,0];
                this.sort = goodsType[this.active];
                //获取商品（根据细分类获取商品）
                getProductListByCategory({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    sort: this.sort,
                    categoryId: this.conditionCategory,
                    brandId: this.conditionBrand,
                    keyword: this.keyword,
                    publishStatus:this.publishStatus,
                    minPrice:'',
                    maxPrice:'',
                }).then(res => {
                    if(this.refreshing) {
                        this.refreshing = false;
                        //刷新时候所有商品东西
                        res.data.list.forEach(tiem =>{
                            this.goodsList.push(tiem);
                        })
                    }else{
                        //第一次加载 商品
                        res.data.list.forEach(tiem =>{
                            this.goodsList.push(tiem);
                        })
                    }
                    if(!res.data.list) {
                        this.finished = true
                    } else if(res.data.list.length < this.pageSize){
                        this.finished = true
                    }
                    this.loading = false;
                    this.pageNum++;
                }).catch( err => {
                    this.refreshing = false;
                    this.loading = false
                    this.finished = true
                })
            },
            loadDelay(){
                //弹窗显示
                Toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                });
                setTimeout(() => {
                    Toast.clear();
                    this.onLoad();
                }, 1000);

            },
            addCondition(type, id){
                if(type == 'brand' && this.conditionBrand == id){
                    this.conditionBrand = '';
                }else if (type == 'brand' && this.conditionBrand != id) {
                    this.conditionBrand = id;
                }

                if(type == 'category' && this.conditionCategory == id){
                    this.conditionCategory = '';
                }else if (type == 'category' && this.conditionCategory != id) {
                    this.conditionCategory = id;
                }
            },
            conditionDelete() {
                this.conditionBrand = '';
                this.conditionCategory = '';
            },
            conditionSub() {
                this.conditionSearch = false;
                this.onRefresh()
            },
            checkShow (name, title) {
                if(name == 3){    //点击筛选时
                    this.conditionSearch = true;
                    if(this.$route.query.categoryPid != undefined){
                        //获取筛选分类
                        getCategory(this.$route.query.categoryPid).then(res=>{
                            this.categoryList = res.data
                        })
                        getBrandList({pageNum: 1, pageSize: 20}).then(res => {
                            this.brandList = res.data
                        })
                    }
                }else {
                    this.conditionSearch = false;
                }
            }
        },
        watch: {
            active: function () {
                if(this.active == 3){
                    this.conditionSearch = true
                }else {
                    this.onRefresh()
                }
            }
        },
        created() {
            //获取语言包
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    #GoodsList{
        background: #f8f6f7;
        height: 1000px;
        width: 100%;
    }

    .van-nav-bar {
        /*box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);*/
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #ffffff;
    }

    .van-search {
        padding: 0;
    }

    .van-tabs {
        margin-top: 46px;
    }

    ::v-deep .van-tabs__wrap {
        position: fixed;
        left: 0;
        right: 0;
        top: 46px;
        z-index: 100;
    }

    ::v-deep .van-tabs__content {
        padding-top: 55px;
    }

    .goods-condition {
        bottom: 0;
        background-color: #f8f6f7;
        position: fixed;
        left: 0;
        right: 0;
        top: 90px;
        border-top: 1px solid #eee;
    }

    .condition-name {
        color: #666;
        font-size: 16px;
        margin-top: 10px;
    }

    .condition-button {
        width: 100%;
        text-align: center;
        height: 30px;
        background-color: #ffffff;
        line-height: 30px;
        border-radius: 12px;
        font-weight: 700;
    }

    .select-condition {
        border: 1px solid ;
        color: white;
        box-sizing: border-box;
        background-color: #1989f9;
        font-weight: 700;
    }

    ::v-deep .van-grid-item__content {
        padding: 5px 8px;
        background-color: #f8f6f7;
    }
    ::v-deep .van-grid {
        margin-top: 10px;
    }

    .condition-sub {
        display: flex;
        height: 45px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        border-top: 1px solid #ccc;
    }

    .condition-delete {
        flex: 1;
        line-height: 45px;
        color: #1989f9;
    }

    .condition-sure {
        flex: 1;
        line-height: 45px;
        background-color: #1989f9;
        color: white;
    }
</style>
